import { useCallback } from "react";
import { useI18n } from "./i18n-hooks";
import { buildDescription } from "../ui_atoms/ListItem";

export const useBuildIjmDescription = (separator?: string) => {
    const i18n = useI18n();
    return useCallback(
        (name?: string, payFirstDays?: boolean | null, payRemainingPercents?: number | null) => {
            if (!name) {
                return i18n.t("ijm.no_ijm");
            }
            const ret = [] as Array<string>;
            if (name) {
                ret.push(name);
            }
            if (payFirstDays !== undefined && payFirstDays !== null) {
                ret.push(
                    payFirstDays
                        ? i18n.t("ijm.ijm_pay_first_days.in_list.yes")
                        : i18n.t("ijm.ijm_pay_first_days.in_list.no"),
                );
            }
            if (payRemainingPercents !== undefined && payRemainingPercents !== null) {
                ret.push(i18n.t(`ijm.ijm_pay_remaining_percents.in_list.${payRemainingPercents}`));
            }
            return buildDescription(ret, { separator });
        },
        [i18n, separator],
    );
};
